import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from 'ionic-angular';
import { UserListPickerControlComponent } from './user-list-picker-control.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        UserListPickerControlComponent
    ],
    exports: [
        UserListPickerControlComponent
    ]
})
export class UserListPickerControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/user-list-picker/form/user-list-picker-control.module.ts